import { MenuItem } from 'primeng/api';
import { RoutesEnum } from '../../../../../shared/models/routes.enum';

export const ACCOUNT_MENU_ITEMS: MenuItem[] = [
  {
    label: 'Mój Profil',
    icon: 'pi pi-user',
    routerLink: `/${RoutesEnum.MyAccount}/${RoutesEnum.MyProfile}`,
  },
  {
    label: 'Edycja Profilu',
    icon: 'pi pi-pencil',
    routerLink: `/${RoutesEnum.MyAccount}/${RoutesEnum.EditProfile}`,
  },
  {
    label: 'Licencja',
    icon: 'pi pi-id-card',
    routerLink: `/${RoutesEnum.MyAccount}/${RoutesEnum.Licence}`,
  },
  {
    label: 'Zmiana hasła',
    icon: 'pi pi-key',
    routerLink: `/${RoutesEnum.MyAccount}/${RoutesEnum.ChangePassword}`,
  },
];
